import { useContext } from "react";
import { SourcesContext } from "../contexts/sources/SourcesContext";

const useSources = () => useContext(SourcesContext);

export default useSources;
